import { render } from "./AllStudents.vue?vue&type=template&id=07a43480&scoped=true"
import script from "./AllStudents.vue?vue&type=script&lang=js"
export * from "./AllStudents.vue?vue&type=script&lang=js"

import "./AllStudents.vue?vue&type=style&index=0&id=07a43480&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07a43480"]])

export default __exports__